<template>
  <div class="dingshi">
    <div class="top">
        <van-icon size="22px" name="arrow-left" @click="back" />
        <span class="title">{{ $t('append_field.schedule_on_off') }}</span>
    </div>
    <div class="dingshi-content" v-if="clientTaskInfos.length > 0" >
      <van-cell>
        <div class="dingshi-text">{{ $t('append_field.adding_one_will_override_the_previous')}}</div>
      </van-cell>
      <van-cell
          :title="$t('append_field.shutdown_time')"
          :disabled="true"
          class="custom-field"
      > {{ end_time }}</van-cell>
      <van-cell
          :title="$t('append_field.startup_time')"
          :disabled="true"
          class="custom-field"
      > {{ start_time }}</van-cell>
      <van-cell
          :title="$t('append_field.taskPeriod')"
          :disabled="true"
          class="custom-field"
      />
      <div style="padding: 10px 16px;display: flex;flex-wrap:wrap">
        <div style="flex: 1;display: flex;justify-content: center;" v-for="(item,index) in checkboxData"
             :key="index">
          <div
              style="width: 40px;height: 40px;display: flex;justify-content: center;line-height:34px;align-items: center"
              :class="item.value ? 'yes' :'no'">
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
    <van-empty
        v-else
        class="custom-image"
        image="/static/images/terminal/empty-img.png"
        :description="$t('append_field.data_empty')"
    />
    <div class="dingshi-exit">
      <van-button color="#006EFF"  @click="onEdit" size="small">
        {{ $t('append_field.add') }}
      </van-button>
    </div>

    <van-dialog v-model="show1"
                class="schedule-onoff"
                :title="$t('append_field.schedule_on_off')" show-cancel-button
                @confirm="onDingshi"
                :beforeClose="vBeforeClose"
                @cancel="timeCancel(1)">
      <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="end_time"
          :label-width="'120px'"
          :label="$t('append_field.shutdown_time')"
          :placeholder="$t('append_field.please_select_time')"
          @click="timeShow = true"
      />

      <van-field
          readonly
          clickable
          :label-width="'120px'"
          name="datetimePicker"
          :value="start_time"
          :label="$t('append_field.startup_time')"
          :placeholder="$t('append_field.please_select_time')"
          @click="timeShow2 = true"
      />
      <div style="padding: 20px 16px;display: flex;flex-wrap:wrap">
        <div style="flex: 1;display: flex;justify-content: center;font-size:  15px;" v-for="(item,index) in checkboxData"
             :key="index">
          <div @click="setCheckbox(item.label)"
               style="width: 40px;height: 40px;display: flex;justify-content: center;line-height:34px;align-items: center"
               :class="item.value ? 'yes' :'no'">
            {{ item.label }}
          </div>
        </div>
      </div>
    </van-dialog>
    <van-popup v-model="timeShow" position="bottom">
      <van-datetime-picker
          type="time"
          :title="$t('append_field.shutdown_time')"
          @confirm="onConfirm"
          @cancel="timeCancel(0)"
      />
    </van-popup>
    <van-popup v-model="timeShow2" position="bottom">
      <van-datetime-picker
          type="time"
          :title="$t('append_field.startup_time')"
          @confirm="onConfirm2"
          @cancel="timeCancel(2)"
      />
    </van-popup>
  </div>
</template>
<script>
import qs from "qs";
import {Toast} from "vant";
import {vBeforeClose} from "@/utils/tool";

export default {
  data() {
    return {
      show1:false,
      timeShow:false,
      timeShow2:false,
      clientTaskInfos: [],
      id:1,
      clNo: '',
      checkboxData: [
        {value: true, label: this.$t('append_field.mon')},
        {value: true, label: this.$t('append_field.tue')},
        {value: true, label: this.$t('append_field.wed')},
        {value: true, label: this.$t('append_field.thu')},
        {value: true, label: this.$t('append_field.fri')},
        {value: true, label: this.$t('append_field.sat')},
        {value: true, label: this.$t('append_field.sun')}
      ],
      start_time: "",
      end_time: "",
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.clNo = this.$route.query.clNo
    this.getClientInfo()
    const tabbar = document.querySelector('.van-tabbar')
    tabbar.style.display = 'none'
    this.getDingshiInfo()
    document.title = this.$t('append_field.schedule_on_off')
  },
  methods: {
    vBeforeClose,
    onConfirm2(value){
      this.start_time = value
      this.timeShow2 = false
    },
    onConfirm(value){
      this.end_time = value
      this.timeShow = false
    },
    onEdit() {
      this.show1 = true
    },
    timeCancel(v){
      switch (v){
        case 0:
          this.timeShow = false
          break
        case 1:
          this.show1 = false
          this.end_time = ''
          this.start_time = ''
          break
        case 2:
          this.timeShow2 = false
          break
      }
      this.getDingshiInfo()
    },
    getDingshiInfo() {
      if (this.clientTaskInfos.length === 0) return
      this.start_time = this.clientTaskInfos[0].ttOnTime
      this.end_time =this.clientTaskInfos[0].ttOffTime
      this.checkboxData[0].value = this.clientTaskInfos[0].ttMon === "true"
      this.checkboxData[1].value = this.clientTaskInfos[0].ttTue === "true"
      this.checkboxData[2].value = this.clientTaskInfos[0].ttWed === "true"
      this.checkboxData[3].value = this.clientTaskInfos[0].ttThu === "true"
      this.checkboxData[4].value = this.clientTaskInfos[0].ttFri === "true"
      this.checkboxData[5].value = this.clientTaskInfos[0].ttSat === "true"
      this.checkboxData[6].value = this.clientTaskInfos[0].ttSun === "true"
    },
    setCheckbox(val) {
      let index = this.checkboxData.map(res => res.label).indexOf(val)
      this.checkboxData[index].value = !this.checkboxData[index].value

      this.$set(this.checkboxData, index, this.checkboxData[index])
      this.checkall = true

      for (let i = 0; i < this.checkboxData.length; i++) {
        if (!this.checkboxData[i].value) {
          this.checkall = false
          break
        }
      }
    },
    onDingshi() {
      if(!this.start_time||!this.end_time){
        Toast(this.$t('append_field.please_select_time'),'fail')
        return
      }
      // 检查是否至少选择了一个日期
      const isAnyDaySelected = this.checkboxData.some(day => day.value);
      if (!isAnyDaySelected) {
        Toast(this.$t('append_field.please_select_date'), 'fail');
        return;
      }
      this.$ajax.post("/etv/socket.json", {
        instruction: 5012,
        clientIdList: [this.id]
      }).then(res => {
        if (res.data.code === 0) {
          this.$ajax({
            url: "/etv/insertTimedTask.json",
            method: "post",

            data: {
              clientIdList:[this.id],
              timedTaskList: [
                {
                  ttMon: this.checkboxData[0].value,
                  ttTue: this.checkboxData[1].value,
                  ttWed: this.checkboxData[2].value,
                  ttThu: this.checkboxData[3].value,
                  ttFri: this.checkboxData[4].value,
                  ttSat: this.checkboxData[5].value,
                  ttSun: this.checkboxData[6].value,
                  ttOffTime: this.end_time,
                  ttOnTime: this.start_time,
                  ttState: true,
                  checkall: this.checkall,
                }
              ],

            }
          }).then(res => {
            if (res.data.code === 0) {
              Toast(res.data.msg)
              this.getClientInfo()
              this.getDingshiInfo()
            } else {
              Toast(res.data.msg)
            }
            this.show1 = false
          })
        }
      })
    },
    getClientInfo() {
      this.$ajax.post('/etv/selectClientByClId.json', qs.stringify({
        id: this.id,
      })).then(res => {
        if (res.data.code === 0) {
          this.clientTaskInfos = res.data.data.clientTaskInfo
          this.getDingshiInfo()
        }
      })

    },
    back() {
      this.$router.back()
    }
  }

}
</script>

<style scoped lang="scss">

.dingshi {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  gap: 16px; /* 添加间距 */
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;

    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .van-cell{
    font-size: 18px !important;
    padding: 20px;
  }

  .yes {
    background: #006EFF;
    color: #fff;
  }

  .no {
    background: #dadada;
    color: #333333;
  }
  .dingshi-text {
    font-size:  15px;
    color: red;
  }
  .dingshi-exit {
    position: fixed;
    right: 0;
    bottom: 10px;
    left: 0;
    height: 40px;
    display: flex;
    margin: 0 15px;
    justify-content: center;
    align-items: center;


    .van-button{
      padding: 0 15px !important;
    }
    .dingshi-edit-icon {
      width: 40px;
      height: 40px;
      border: 1px solid #dadada;
      overflow: hidden;
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .edit-icon-img {
      width: 100%;
      height: 100%;
    }
  }

  .dingshi-content {
    position: fixed;
    left: 0px;
    top: 70px;
    width: 100%;
    box-sizing: border-box;
    background: white;

    .custom-field .van-field__control {
      color: #333333;
    }

    .checkbox-container {
      padding: 10px 16px;
      display: flex;
      flex-wrap: wrap;
      gap: 10px; /* 添加间距 */
    }

    .checkbox-item {
      flex: 1;
      display: flex;
      justify-content: center;
    }

    .checkbox-circle {
      width: 35px;
      height: 35px;
      display: flex;
      justify-content: center;
      align-items: center;

      line-height: 34px;
    }



    .nut-textinput-disabled input {
      background-color: white;
    }

    .nut-textinput {
      padding: 0 16px;
      border-bottom: 1px solid #dddfe6;
    }

    .nut-textinput input {
      border: none;
      padding: 0 !important;
      text-align: right;
    }
  }
}

</style>